<template>
  <div v-if="!loading" class="layout" style="background-color: #f5f5f5">
    <van-tabs class="vantabs" v-model="active" animated swipeable color="#2E94E5" line-height="3px"
      title-active-color="#2E94E5">
      <van-tab v-for="item in navData" :key="item.text" :title="item.text">
        <component v-if="item.show" :is="item.url" :list.sync="item.data" @show-dialog="showDialog"></component>
      </van-tab>
    </van-tabs>
    <van-popup v-model="showSigns" closeable :style="{ height: '80%' }">
      <div class="sign-middle">
        <img src="http://img.xiaoqijiankang.com/images/signs.jpg" />
      </div>
    </van-popup>
    <BottomNav v-if="showNav == 1" />
  </div>
</template>
<script>
import Organ from "@/components/Organ"
import Summary from "@/components/SummaryFullView"
import Physiology from "@/components/Physiology"
import Brain from "@/components/Brain"
import Diabetes from "@/components/Diabetes"
import Disease from "@/components/DiseaseFullView"
import translate from "./PeaceMindH5/components/translate";
import SeriousDis from "@/components/SeriousDis"
import Healthy from "@/components/HealthyFullView"
import BottomNav from "@/components/BottomNav"
import Report from "../models/Report"
export default {
  components: { Summary, Physiology, Brain, Diabetes, Disease, Healthy, Organ, BottomNav, SeriousDis, translate },
  data() {
    return {
      showSigns: false,
      active: 0,
      loading: true,
      navData: [
        { text: '健康概况', url: 'Organ', list: 'organ', show: true, },
        { text: '健康总评', url: 'Summary', list: 'summary', show: true, },
        { text: '生理系统风险', url: 'Physiology', list: 'physiology', show: true, },
        { text: '脑血管风险', url: 'Brain', list: 'brain', show: true, },
        { text: '糖尿病风险', url: 'Diabetes', list: 'Diabetes', show: true, },
        { text: '疾病风险', url: 'Disease', list: 'Disease', show: true, },
        { text: '健康管理建议', url: 'Healthy', list: 'healthy', show: true, },
        { text: '重疾风险', url: 'SeriousDis', list: 'SeriousDis', show: true, },
        { text: '人体成分', url: 'translate', show: true, data: [] }
      ],

    }
  },
  computed: {
    id() {
      return this.$route.query.id || ''
    },
    user_no() {
      return this.$route.query.user_no || ''
    },
    showNav() {
      return this.$route.query.showNav || 0
    },
  },
  methods: {
    showDialog() {
      this.showSigns = true;
    },
    oylstatus(status) {
      let level;
      switch (status) {
        case 1:
          level = 5
          break;
        case 2:
          level = 4
          break;
        case 3:
          level = 3
          break;
        case 4:
          level = 2
          break;
        case 5:
          level = 1
          break;
      }
      return level
    },
     // 健康管理建议
     handleObJToArrJk(system, ear_yer) {
      
      const arr = []
      for (let key in system) {
        system[key].forEach((item) => {
          if (item.level >= 4) {
            arr.push(item)
          }
        })
      }
      const arrBox = arr.concat(ear_yer)
      arrBox.forEach(e => {
        e.btntxt = "查看建议";
          e.showCon = false
        e.performance = e.performance ? e.performance.split('\\r\\n') : []
        e.suggestion = e.suggestion ? e.suggestion.split('\\r\\n') : []
      })

      this.navData[6].data = arrBox
    },
     // 疾病风险格式处理
     handleObJToArr(obj) {
      const arr = []
      for (let key in obj) {
        if (obj[key].name) {
          arr.push(
            {
              ...obj[key],
              title: key
            })
        }
      }
      arr.forEach(e => {
        e.performance = e.performance ? e.performance.split('\\r\\n') : []
        e.suggestion = e.suggestion ? e.suggestion.split('\\r\\n') : []
      })

      this.navData[5].data = arr
    },
    /** 对象转数组 */
    objToArray(obj) {
      let arr = [];
      for (const key in obj) {
        arr.push({ title: key, ...obj[key] });
      }
      return arr;
    },
  },
  created() {
    let params = {
      user_no: this.user_no,
      test_report_id: this.id
    }
    Report.getReports({ ...params }, (res, err) => {
      this.loading = true
      if (!err) {
        res.healthy.forEach(e => {
          e.btntxt = "查看建议";
          e.showCon = false
        });
        console.log(111)
        console.log(res.special)
        res.special.forEach((item) =>{
          if (item.title == '机能水平' || item.title == '抗氧化能力') {
          let abc = 0;
          switch (item.status) {
            case 1:
              abc = 5;
              break;
            case 2:
              abc = 4;
              break
            case 3:
              abc = 3;
              break
            case 4:
              abc = 2;
              break;
            case 5:
              abc = 1;
              break

          }
          item.status = abc
        }else if(item.title =='自主神经功能'){
          let statusList = [3, 2, 5, 6, 1, 4];
            let newStatus = statusList[item.status - 1];
            item.status = newStatus
        }
          item.suggestion = item.suggestion ? item.suggestion.split('\\r\\n') : []
        })
        //res.diabetes.descArr = res.diabetes.diabetes_desc.split('\\r\\n');
        res.brain.descArr = res.brain.brain_desc.split('\\r\\n');
      
        res.special[4].status = this.oylstatus(res.special[4].status)
        for (let key in res.physiology_system) {
          res.physiology_system[key].forEach(e => {
            e.showDetail = false;
            e.remakrs = e.remakrs ? e.remakrs.split('\\r\\n') : []
          })
        }
        this.navData[0].data = res;
        this.navData[1].data = res.special;
        this.navData[2].data = {
          ...res.physiology,
          physiology_system: res.physiology_system
        };

        this.navData[3].data = res.brain;
        this.navData[4].data = res.diabetes;
        if (res.sn == 30004 || res.sn == 10099) { // 30004 
          this.navData[8].data = res.rtcffx // 人体成分
          this.navData[8].data.forEach((item) => {
            if (item.name == '基础代谢' || item.name == '体重指数') {
              item.danwei = ""
            } else {
              item.danwei = "kg"
            }
          })
        }else{
          this.navData.splice(8, 1)
        }
        if (res.company_id == 170 || res.company_id == 171) {
          localStorage.setItem('company_id', res.company_id)
          this.navData[5].text = '疾病提示'
          this.navData[7].data = res.serious_disease
        } else {
          this.navData.splice(7, 1)
        }
       
          // this.navData[6].data = {
          //   healthy: res.healthy,
          //   marks: res.marks
          // }
          this.handleObJToArrJk(res.physiology_system, res.ear_yer_health_advice)
          this.handleObJToArr(res.disease_risk_management)
          // this.navData[5].data = res.disease

        if (res.is_show_survey === 1) {
          this.navData[0].text = '免疫风险等级'
          this.navData.splice(1, 5);
        }


        this.loading = false
      }
    })
  }
}
</script>
<style lang="scss" >
.layout {
  height: 100%;
}

.van-tabs--line .van-tabs__wrap {
  height: 80px !important;
  line-height: 80px;
  margin-bottom: 20px;
  width: 100%;
  font-size: 30px;
}

.van-tab__text {
  font-size: 30px;
}

.van-tabs__wrap--scrollable .van-tab {
  //    flex: 0 0 27% !important;
  font-size: 30px;
}

.vantabs {
  font-size: 30px;
  //    height: calc(100% - 100px);
  padding-bottom: 100px;
}
</style>